import AccountBoxIcon from '@mui/icons-material/AccountBox';
import ListAltIcon from '@mui/icons-material/ListAlt';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SettingsIcon from '@mui/icons-material/Settings';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import GavelIcon from '@mui/icons-material/Gavel';
import MedicationIcon from '@mui/icons-material/Medication';
import HelpIcon from '@mui/icons-material/Help';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import BedIcon from '@mui/icons-material/Bed';
import BallotIcon from '@mui/icons-material/Ballot';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import BedroomChildIcon from '@mui/icons-material/BedroomChild';
import AddAlertIcon from '@mui/icons-material/AddAlert';
import MoodBadIcon from '@mui/icons-material/MoodBad';
import HomeIcon from '@mui/icons-material/Home';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import FeaturedPlayListIcon from '@mui/icons-material/FeaturedPlayList';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';

const icons = [
  {
    id: 'LocalHospitalIcon',
    icon: LocalHospitalIcon,
  },
  {
    id: 'FormatListNumberedIcon',
    icon: FormatListNumberedIcon,
  },
  {
    id: 'AccountBoxIcon',
    icon: AccountBoxIcon,
  },
  {
    id: 'ListAltIcon',
    icon: ListAltIcon,
  },
  {
    id: 'WhatsAppIcon',
    icon: WhatsAppIcon,
  },
  {
    id: 'SettingsIcon',
    icon: SettingsIcon,
  },
  {
    id: 'CalendarMonthIcon',
    icon: CalendarMonthIcon,
  },
  {
    id: 'GavelIcon',
    icon: GavelIcon,
  },
  {
    id: 'MedicationIcon',
    icon: MedicationIcon,
  },
  {
    id: 'HelpIcon',
    icon: HelpIcon,
  },
  {
    id: 'LibraryBooksIcon',
    icon: LibraryBooksIcon,
  },
  {
    id: 'BedIcon',
    icon: BedIcon,
  },
  {
    id: 'BallotIcon',
    icon: BallotIcon,
  },
  {
    id: 'ManageAccountsIcon',
    icon: ManageAccountsIcon,
  },
  {
    id: 'BedroomChildIcon',
    icon: BedroomChildIcon,
  },
  {
    id: 'AddAlertIcon',
    icon: AddAlertIcon,
  },
  {
    id: 'MoodBadIcon',
    icon: MoodBadIcon,
  },

  {
    id: 'HomeIcon',
    icon: HomeIcon,
  },
  {
    id: 'PeopleAltIcon',
    icon: PeopleAltIcon,
  },
  {
    id: 'FeaturedPlayListIcon',
    icon: FeaturedPlayListIcon,
  },
  {
    id: 'ContactSupportIcon',
    icon: ContactSupportIcon,
  },
  {
    id: 'PictureAsPdfIcon',
    icon: PictureAsPdfIcon,
  }
  


];

export default icons;
